import React from 'react'

function Footer() {
  return (
    <div style={{marginTop: 8, paddingBottom: 16, textAlign: "center"}}>
    <a target='_blank' href='mailto:contact@dogenano.com'>
      Contact
    </a><br/> <br/>
    DogeNano © {new Date().getFullYear()} 
</div>
  )
}

export default Footer